module.exports = __webpack_public_path__ + "static/media/page-banner.41d31c2a.jpg";